import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { defer, Observable, throwError as observableThrowError, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { timeoutError } from '../../models/timeout-error';
import { TimeoutLimit } from '../../models/timeout-limit';
import { GlobalEvent, GlobalEventService } from '../global-event-service/global-event.service';
import { PullVcrCtrlRequest } from '../../models/sabre-engine/pull-vcr-ctrl-request';
import { PullVcrCtrlAndTicketDataResponse } from '../../models/sabre-engine/pull-vcr-ctrl-and-ticket-data-response';

export interface SabreEngineServiceApi {
  pullVcrControl(request: PullVcrCtrlRequest): Observable<PullVcrCtrlAndTicketDataResponse | Error>;
}

@Injectable({
  providedIn: 'root',
})
export class SabreEngineService implements SabreEngineServiceApi {
  private readonly http = inject(HttpClient);
  private readonly eventService = inject(GlobalEventService);

  pullVcrControl(request: PullVcrCtrlRequest): Observable<PullVcrCtrlAndTicketDataResponse | Error> {
    const background = 'false';
    const options = {
      headers: new HttpHeaders({ background }),
    };
    return this.http.post<PullVcrCtrlAndTicketDataResponse>('api/sabreengine/pullctrl', request, options).pipe(
      timeout({
        each: TimeoutLimit.MEDIUM,
        with: () => defer(() => observableThrowError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((response) => response),
      catchError((err) => {
        this.eventService.broadcastAjax(GlobalEvent.AJAX_END, err);
        return throwError(() => err);
      })
    );
  }
}
